<ng-template>
  <div class="stbui-popover-container" #focusTrapElement>
    <ng-content></ng-content>
  </div>
</ng-template>